import withDashboardLayout from '../../hoc/withDashboardLayout';
import { CaretDownOutlined } from '@ant-design/icons';
import { Select, DatePicker, Dropdown, Modal, Button, message, Empty } from 'antd';
import UserDashboard from '../../assets/dashboard/user-dashboard.svg';
import ServiceDashboard from '../../assets/dashboard/service-dashboard.svg';
import GoogleAnalyticsImg from '../../assets/dashboard/google-analytics.svg';
import SubscriptionDashboard from '../../assets/dashboard/subscription-dashboard.svg';
import CalenderDashboard from '../../assets/dashboard/calendar-dashboard.svg';
import StarIcon from '../../assets/star-icon.png';
import { CaretDownFilled } from '@ant-design/icons';
import { Chart as ChartJS, registerables } from 'chart.js';
import { Bar, Doughnut } from 'react-chartjs-2';
import 'chartjs-plugin-annotation';
import { useNavigate } from 'react-router';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import Loader from './../../components/shared/Loader';
import { GetAllReviews, GetDashboardData, UpdateServiceProviderReviews } from '../../utils/api';
import { Link } from 'react-router-dom';
import { useGlobalContext } from '../../context/GlobalProvider';
import { imgPath } from '../../utils/axiosInstance';
import Logo from '../../assets/logo.png';
ChartJS.register(...registerables);


const dropdownItems = [
    {
        label: 'Published',
        key: 0,
    },
    {
        label: 'Unpublished',
        key: 2,
    },
];


const Dashboard = () => {

    const AnalyticsLink = 'https://console.firebase.google.com/u/0/project/beauty-spot-be044/analytics/app/android:com.app.beautyspotapp/overview';

    const { isMobile } = useGlobalContext();
    const navigate = useNavigate();
    const { RangePicker } = DatePicker;
    const [modalData, setModalData] = useState({ visible: false, selectedStatus: null, review: null });
    const [selectedOption, setSelectedOption] = useState('thisWeek');
    const [dashboardData, setDashboardData] = useState({
        clientsCount: 0,
        serviceProvidersCount: 0,
        signupsCount: 0,
        bookNowClicksCount: 0,
        clientsAccountDeleted: 0,
        serviceProviderAccountDeleted: 0,
        totalAccountsDeleted: 0,
    });
    const [signUpData, setSignUpData] = useState({
        period: [],
        clientData: [],
        providerData: []
    });
    const [bookNowData, setBookNowData] = useState({
        period: [],
        bookNowClicksData: [],
    });
    const [serviceProviders, setServiceProviders] = useState([]);
    const [reviews, setReviews] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [loading, setLoading] = useState(true);
    const [btnLoading, setBtnLoading] = useState(false);

    // const [selectedOptionFor, setSelectedOptionFor] = useState('all');
    // const [selectedTotalSignupsOption, setSelectedTotalSignupsOption] = useState('thisMonth');
    // const [selectedTotalBookOption, setSelectedTotalBookOption] = useState('thisMonth');
    // const [selectedServiceProvidersOption, setSelectedServiceProvidersOption] = useState('thisMonth');
    // const [selectedAccountDeletedOption, setSelectedAccountDeletedOption] = useState('thisMonth');



    const handleSelectChange = (option) => {
        setSelectedOption(option);
        // setSelectedOptionFor(type);
        // switch (type) {
        //     case 'all':
        //         setSelectedAllOption(option);
        //         break;
        //     case 'totalSignups':
        //         setSelectedTotalSignupsOption(option);
        //         break;
        //     case 'totalBookNow':
        //         setSelectedTotalBookOption(option);
        //         break;
        //     case 'serviceProviders':
        //         setSelectedServiceProvidersOption(option);
        //         break;
        //     case 'accountDeleted':
        //         setSelectedAccountDeletedOption(option);
        //         break;
        //     default:
        //         break;
        // }
    };

    // useEffect(() => {
    //     if (selectedAllOption === 'custom' ||
    //         selectedTotalSignupsOption === 'custom' ||
    //         selectedTotalBookOption === 'custom' ||
    //         selectedServiceProvidersOption === 'custom' ||
    //         selectedAccountDeletedOption === 'custom') {
    //         setSelectedRange([]);
    //     }
    // }, [selectedAllOption, selectedTotalSignupsOption, selectedTotalBookOption, selectedServiceProvidersOption, selectedAccountDeletedOption])

    const onRangeChange = (dates) => {
        if (dates === null) {
            setEndDate(null)
            setStartDate(null)
        }
        // if (dates && dates.length === 2) {
        //     const startDate = dates[0].format('YYYY-MM-DD');
        //     const endDate = dates[1].format('YYYY-MM-DD');
        //     if (startDate) {
        //         setStartDate(startDate);
        //     }
        //     if (endDate) {
        //         setEndDate(endDate);
        //     }
        // }
        else if (dates.length === 2) {
            const [start, end] = dates.map((date) => date.format("YYYY-MM-DD"));
            setStartDate(start);
            setEndDate(end);
        }
    };

    const totalSignupChartData = {
        labels: signUpData?.period,
        datasets: [
            {
                label: 'Clients',
                data: signUpData?.clientData,
                backgroundColor: '#56D863',
                borderColor: 'transparent',
                borderWidth: 2,
                barThickness: 13,
            },
            {
                label: 'Service Providers',
                data: signUpData?.providerData,
                backgroundColor: '#FFC400',
                borderColor: 'transparent',
                borderWidth: 2,
                barThickness: 13,
            },
        ],
    };


    const totalBookNowData = {
        labels: bookNowData?.period,
        datasets: [
            {
                label: 'Book Now Clicks',
                data: bookNowData?.bookNowClicksData,
                backgroundColor: '#E37400',
                borderColor: 'transparent',
                borderWidth: 2,
                barThickness: 13,
            },
        ],
    };


    const options = {
        responsive: true,
        scales: {
            y: {
                border: { dash: [4, 4] },
                ticks: {
                    display: true,
                    // stepSize: 100,
                },
            },
            x: {
                grid: {
                    display: false,
                },
                ticks: {
                    display: true,
                }
            },
        },
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: false,
            },
        },
    };


    const pieData = {
        labels: ['Clients', 'Service Providers'],
        datasets: [
            {
                data: [dashboardData?.clientsAccountDeleted, dashboardData?.serviceProviderAccountDeleted],
                backgroundColor: ['#FFC400', '#56D863'],
            },
        ],
    };

    const pieOptions = {
        responsive: true,
        cutout: "85%",
        plugins: {
            legend: {
                display: false,
            },
        },
        layout: {
            padding: 20,
        },
        annotation: {
            annotations: [
                {
                    drawTime: 'afterDatasetsDraw',
                    type: 'text',
                    id: 'text-center',
                    x: '50%',
                    y: '50%',
                    fontColor: '#000',
                    text: 'Center Text',
                    fontSize: 12,
                },
            ],
        },
    };



    const fetchReviews = async () => {
        try {
            setLoading(true);
            const response = await GetAllReviews('serverPaging=false');
            if (response?.isSuccess) {
                setReviews(response?.items)
                setLoading(false);
            } else {
                message.error(response?.error);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    };

    const handleActionModalOpen = (action, status, review) => {
        if (action === 'changeStatus') {
            setModalData({ visible: true, selectedStatus: status, review: review });
        }
    };

    const handleChangeStatusOk = async () => {
        try {
            setBtnLoading(true);
            const res = await UpdateServiceProviderReviews({ status: modalData?.selectedStatus }, modalData?.review?.id);
            setBtnLoading(false);
            if (res?.isSuccess) {
                message.success('Status updated successfully');
                fetchReviews();
                setModalData({ visible: false, selectedStatus: null, review: null });
            }
        } catch (error) {
            setBtnLoading(false);
            message.error('Error in updating status, Try again later');
        }
    }

    const handleModalCancel = () => {
        setModalData({ visible: false, selectedStatus: null, review: null });
    }




    const getData = async (params) => {
        const duration = [];
        const clientCount = [];
        const providerCount = [];
        const bookNowCount = []
        try {
            setLoading(true);
            const response = await GetDashboardData(params);
            if (response) {
                setDashboardData({
                    clientsCount: response?.clientsCount,
                    serviceProvidersCount: response?.serviceProviderCount,
                    signupsCount: response?.signUpCount,
                    bookNowClicksCount: response?.bookNowClicksCount,
                    clientsAccountDeleted: response?.clientDeletedCount,
                    serviceProviderAccountDeleted: response?.providerDeletedCount,
                    totalAccountsDeleted: response?.totalAccountsDeleted
                });
                setServiceProviders(response?.mostViewedServiceProviderList);
                response?.graphsInfo?.forEach((item) => {
                    duration.push(item?.Day ? item.Day.slice(0, 3) : item.monthName.slice(0, 3));
                    clientCount.push(item.clientCount);
                    providerCount.push(item.providerCount);
                    bookNowCount.push(item.profileBooKCount);
                });

                setSignUpData({
                    period: duration,
                    clientData: clientCount,
                    providerData: providerCount
                });

                setBookNowData({
                    period: duration,
                    bookNowClicksData: bookNowCount
                });

                setLoading(false);
            } else {
                message.error(response?.error);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    useEffect(() => {
        let params = '';
        if (selectedOption === '') {
            if (startDate && endDate) {
                params += `&filter=custom`;
                params += `&startDate=${startDate}`;
                params += `&endDate=${endDate}`;
            } else {
                params += `&filter=custom`;
            }
        } else {
            params += `&filter=${selectedOption}`;
        }
        getData(params);
    }, [selectedOption, startDate, endDate]);


    useEffect(() => {
        fetchReviews();
    }, [])


    if (loading) {
        return <Loader />
    }

    return (
        <div className='w-full h-full'>
            <div className='w-[95%] mx-auto'>

                {/* Dashboard Header */}
                <div className='w-full py-4'>
                    <div className='flex items-center justify-between'>
                        <h2 className='font-semibold text-lg title text-[#000000]'>Dashboard</h2>
                        <div className='flex items-center gap-x-3'>

                            <div className='w-full flex items-center justify-end gap-x-2'>
                                {
                                    selectedOption === ''
                                        ? (
                                            <div>
                                                <RangePicker
                                                    value={[startDate ? dayjs(startDate) : null, endDate ? dayjs(endDate) : null]}
                                                    onChange={onRangeChange}
                                                    format='D MMM YY'
                                                    disabledDate={(current) => current && current > dayjs().endOf('day')}
                                                />
                                            </div>
                                        ) : ''
                                }
                                <Select
                                    suffixIcon={<CaretDownOutlined />}
                                    className='w-32'
                                    value={selectedOption}
                                    onChange={(option) => handleSelectChange(option)}>
                                    <Select.Option value='today'>Today</Select.Option>
                                    <Select.Option value='thisWeek'>This Week</Select.Option>
                                    <Select.Option value='lastMonth'>Last Month</Select.Option>
                                    <Select.Option value='quarter'>This Quarter</Select.Option>
                                    <Select.Option value='thisYear'>This Year</Select.Option>
                                    <Select.Option value=''>Custom</Select.Option>
                                </Select>

                            </div>

                            <Link to={AnalyticsLink} target='_blank' className='sm:flex hidden flex-shrink-0 items-center gap-x-2 text-[10px] bg-white rounded-md p-2 cursor-pointer'>
                                <img className='w-3 h-3' src={GoogleAnalyticsImg} alt="google-analytics" />
                                <span className='text-[#818181] text-xs'> Google Analytics</span>
                            </Link>
                        </div>
                    </div>
                </div>

                {/* Dashboard */}
                <div className='w-full min-h-[calc(100vh-110px)] flex flex-col gap-y-5 box-shadow rounded-t-2xl p-5 bg-white'>

                    {/* Numeric Stats */}
                    <div className=' w-full flex flex-wrap flex-col sm:flex-row items-center gap-5 leading-4'>
                        <div className='w-full flex-1 flex items-center gap-x-2 bg-[#e0edff] px-3 py-3 rounded-2xl'>
                            <img className='w-10 h-10' src={UserDashboard} alt="user-icon" />
                            <div className='flex flex-col items-start'>
                                <span className='font-bold pt-0.5 text-[#222222]'>{dashboardData?.clientsCount}</span>
                                <span className='text-[11px] 2xl:text-xs font-medium text-[#5b5f64]'>Clients</span>
                            </div>
                        </div>
                        <div className='w-full flex-1 flex items-center gap-x-2 bg-[#fff5d7] px-3 py-3 rounded-2xl'>
                            <img className='w-10 h-10' src={ServiceDashboard} alt="user-icon" />
                            <div className='flex flex-col items-start'>
                                <span className='font-bold pt-0.5 text-[#222222]'>{dashboardData?.serviceProvidersCount}</span>
                                <span className='text-[11px] 2xl:text-xs font-medium text-[#5b5f64]'>Service Providers</span>
                            </div>
                        </div>
                        <div className='w-full flex-1 flex items-center gap-x-2 bg-[#e8f7eb] px-3 py-3 rounded-2xl'>
                            <img className='w-10 h-10' src={SubscriptionDashboard} alt="subscription-icon" />
                            <div className='flex flex-col items-start'>
                                <span className='font-bold pt-0.5 text-[#222222]'>{dashboardData?.signupsCount}</span>
                                <span className='text-[11px] 2xl:text-xs font-medium text-[#5b5f64]'>Sign Ups</span>
                            </div>
                        </div>
                        <div className='w-full flex-1 flex items-center gap-x-2 bg-[#f1edeb] px-3 py-3 rounded-2xl'>
                            <img className='w-10 h-10' src={CalenderDashboard} alt="calender-icon" />
                            <div className='flex flex-col items-start'>
                                <span className='font-bold pt-0.5 text-[#222222]'>{dashboardData?.bookNowClicksCount}</span>
                                <span className='text-[11px] 2xl:text-xs font-medium text-[#5b5f64]'>Book Now Clicks</span>
                            </div>
                        </div>
                    </div>

                    {/* Charts */}
                    <div className='w-full flex flex-col sm:flex-row gap-5'>

                        {/* Total Signups */}
                        <div className='box-shadow sm:w-6/12 w-full rounded-xl flex-1 p-6'>

                            <div className='flex items-center text-xs'>
                                <h2 className='text-sm font-semibold text-[#272727]'>Total Signups</h2>
                                <div className=' sm:flex hidden flex-1 justify-center gap-x-8 2xl:gap-x-16'>
                                    <div className='flex gap-x-1 items-center'>
                                        <div className='w-2 h-2 rounded-full bg-yellow-900' />
                                        <p className='text-[10px]'>Clients</p>
                                    </div>
                                    <div className='flex gap-x-1 items-center'>
                                        <div className='w-2 h-2 rounded-full bg-green' />
                                        <p className='text-[10px]'>Service Providers</p>
                                    </div>
                                </div>
                                {/* <Select
                                    suffixIcon={<CaretDownOutlined />}
                                    className='w-32'
                                    value={selectedTotalSignupsOption}
                                    onChange={(option) => handleSelectChange('totalSignups', option)}>
                                    <Select.Option value='today'>Today</Select.Option>
                                    <Select.Option value='thisWeek'>This Week</Select.Option>
                                    <Select.Option value='thisMonth'>This Month</Select.Option>
                                    <Select.Option value='thisQuarter'>This Quarter</Select.Option>
                                    <Select.Option value='thisYear'>This Year</Select.Option>
                                    <Select.Option value='custom'>Custom</Select.Option>
                                </Select> */}

                            </div>

                            <div className='w-full mt-1'>
                                <Bar data={totalSignupChartData} options={options} />
                            </div>

                        </div>

                        {/* Total Book Nows */}
                        <div className='box-shadow sm:w-6/12 w-full rounded-xl flex-1 p-4'>

                            <div className='flex items-center justify-between text-xs'>
                                <h2 className='text-sm font-semibold text-[#272727]'>Total Book Now Clicks</h2>
                                {/* <Select
                                    suffixIcon={<CaretDownOutlined />}
                                    className='w-32'
                                    value={selectedTotalBookOption}
                                    onChange={(option) => handleSelectChange('totalBookNow', option)}>
                                    <Select.Option value='today'>Today</Select.Option>
                                    <Select.Option value='thisWeek'>This Week</Select.Option>
                                    <Select.Option value='thisMonth'>This Month</Select.Option>
                                    <Select.Option value='thisQuarter'>This Quarter</Select.Option>
                                    <Select.Option value='thisYear'>This Year</Select.Option>
                                    <Select.Option value='custom'>Custom</Select.Option>
                                </Select> */}

                            </div>

                            <div className='w-full mt-1'>
                                <Bar data={totalBookNowData} options={options} />
                            </div>

                        </div>

                    </div>

                    {/* Other Stats */}
                    <div className='w-full flex flex-col sm:flex-row gap-5'>

                        {/* Most viewed ServiceProviders */}
                        <div className='sm:w-4/12 w-full py-3 box-shadow rounded-t-xl'>
                            <div className='flex items-start justify-between pb-2 px-3'>
                                <h2 className='text-sm font-semibold'>Most Viewed Service Providers</h2>
                            </div>
                            <div className='overflow-y-scroll h-[242px] no-scrollbar'>
                                {
                                    serviceProviders && serviceProviders?.length > 0 &&
                                    serviceProviders?.map((serviceProvider, i) => {
                                        return (
                                            <div key={serviceProvider?.id} className='flex items-center justify-between py-2 px-3 border-bottom'>
                                                <div className='flex gap-x-4 text-lightGray'>
                                                    <img src={serviceProvider?.image ? `${imgPath}${serviceProvider?.image}` : Logo} alt={serviceProvider?.business_name} className='w-10 h-10 rounded-full object-cover' />
                                                    <div className='flex flex-col justify-center items-start'>
                                                        <span className={'text-black-700 text-sm font-semibold 2xl:text-sm '}>{serviceProvider.business_name}</span>
                                                        <span className={"text-black-700 font-medium text-xs "}>@{serviceProvider?.user_name}</span>
                                                    </div>
                                                </div>
                                                <span className={'text-[11px] 2xl:text-xs font-medium mt-5 text-lightGray '}>{serviceProvider?.profile_view} views</span>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>


                        {/* Reviews */}
                        <div className='sm:w-4/12 w-full py-3 box-shadow rounded-t-xl'>
                            <div className='flex items-center justify-between pb-2 px-3'>
                                <h2 className='text-sm font-semibold'>Reviews</h2>
                                <button className='text-xs font-medium' onClick={() => navigate('/admin/reviews')}>View all</button>
                            </div>
                            <div className='overflow-y-scroll h-[270px] no-scrollbar'>{
                                reviews && reviews?.length > 0
                                    ? reviews?.map(review => {
                                        return (
                                            <div key={review?.id} className="w-full flex flex-col border-bottom gap-y-2 py-2 px-3 poppins">
                                                <div className="flex justify-between items-center">
                                                    <div className="flex gap-x-3">
                                                        <img className="w-10 h-10 rounded-full flex-shrink-0" src={review?.business_Profile?.image ? `${imgPath}${review?.business_Profile?.image}` : Logo} alt="img" />
                                                        <div className="flex flex-col w-full">
                                                            <span className="text-black-700 text-sm font-semibold">{review?.user?.name}</span>
                                                            <span className="text-black-700 font-medium text-xs">@{review?.business_Profile?.user_name}</span>
                                                            <div className="flex items-center gap-x-1">
                                                                <img src={StarIcon} width={16} alt="star-icon" />
                                                                <span className="text-lightGray font-medium text-sm">{review?.rating}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="flex items-center flex-col 2xl:flex-row gap-x-2 gap-y-1">
                                                        <div className='text-right'>
                                                            <span className="text-[11px] font-medium 2xl:text-xs text-lightGray">{dayjs(review?.created_at).format('DD MMM YYYY, h:mm a')}</span>
                                                        </div>
                                                        <div className={`${review.status === 0 ? 'text-[#54a43a] bg-[#f0f7ed]' : 'text-yellow-900 bg-yellow-300'} capitalize border flex items-center gap-x-1 py-1 px-2 text-sm rounded-lg cursor-pointer`}>
                                                            <Dropdown
                                                                menu={{
                                                                    items: dropdownItems.filter(item => item.key !== review?.status),
                                                                    onClick: (e) => handleActionModalOpen('changeStatus', e?.key, review)
                                                                }}
                                                                trigger={['click']}>
                                                                <div className='flex items-center gap-x-1'>
                                                                    <span className="text-xs">
                                                                        {review?.status === 0 ? 'Published' : 'Unpublished'}
                                                                    </span>
                                                                    <button className='text-[10px]'>
                                                                        <CaretDownFilled />
                                                                    </button>
                                                                </div>
                                                            </Dropdown>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="w-[85%]">
                                                    <p className="text-[11px] text-lightGray font-medium">{review?.comment}</p>
                                                </div>
                                            </div>
                                        )
                                    }) : (
                                        <div className="w-full text-center my-24 font-medium text-xl">
                                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                                        </div>
                                    )
                            }</div>
                        </div>


                        {/* Accounts Deleted */}
                        <div className='sm:w-4/12 w-full p-3 box-shadow rounded-t-xl'>
                            <div className='flex items-center justify-between'>
                                <h2 className='text-sm font-semibold'>Accounts Deleted</h2>
                                {/* <Select
                                    suffixIcon={<CaretDownOutlined />}
                                    className='w-32'
                                    value={selectedAccountDeletedOption}
                                    onChange={(option) => handleSelectChange('accountDeleted', option)}>
                                    <Select.Option value='today'>Today</Select.Option>
                                    <Select.Option value='thisWeek'>This Week</Select.Option>
                                    <Select.Option value='thisMonth'>This Month</Select.Option>
                                    <Select.Option value='thisQuarter'>This Quarter</Select.Option>
                                    <Select.Option value='thisYear'>This Year</Select.Option>
                                    <Select.Option value='custom'>Custom</Select.Option>
                                </Select> */}
                            </div>
                            <div className='w-full flex flex-col'>
                                <div className="w-64 h-64 ml-auto total-deleted relative">
                                    <div className='absolute top-[75px] left-[68px] flex flex-col items-center text-center'>
                                        <span className='text-3xl font-bold'>{dashboardData.totalAccountsDeleted}</span>
                                        <span className='text-2xl font-semibold'>Accounts <br /> Deleted</span>
                                    </div>
                                    <Doughnut data={pieData} options={pieOptions} />
                                </div>
                                <div className='-mt-10 flex flex-col gap-y-3'>
                                    <div className='flex gap-x-1 items-center'>
                                        <div className='w-2 h-2 rounded-full bg-yellow-900' />
                                        <span className='2xl:text-sm text-[10px] font-bold mr-1'>{dashboardData?.clientsAccountDeleted}</span>
                                        <p className='text-[10px] 2xl:text-sm text-black-500'>Clients</p>
                                    </div>
                                    <div className='flex gap-x-1 items-center'>
                                        <div className='w-2 h-2 rounded-full bg-green' />
                                        <span className='text-[10px] 2xl:text-sm font-bold mr-1'>{dashboardData?.serviceProviderAccountDeleted}</span>
                                        <p className='text-[10px] 2xl:text-sm text-black-500'>Service Providers</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>


                <Modal
                    centered
                    title='Confirm Status Change'
                    open={modalData.visible}
                    onCancel={!btnLoading ? handleModalCancel : undefined}
                    footer={<div>
                        <Button onClick={handleModalCancel} disabled={btnLoading}>Cancel</Button>
                        <Button type='primary' className='text-white' onClick={handleChangeStatusOk}>
                            Ok
                            {btnLoading && <span className='loader ml-2 align-middle mb-1'></span>}
                        </Button>
                    </div>}
                >
                    {`Are you sure you want to change the status of ${modalData?.review?.business_Profile?.business_name} to ${modalData.selectedStatus === '0' ? 'published' : 'unpublished'}?`}
                </Modal>

            </div>
        </div>
    )
};

export default withDashboardLayout(Dashboard);